<template>
  <div class="row" v-if="(boletos) && (boletos.length)">
    <div class="col-md-12">
      <div class="table-responsive" style="border: 1px solid #EBEDF3; border-radius: 0.42rem; padding: 16px; overflow-x: initial;">
        <h3 class="card-label" style="margin-bottom: 1.75rem;">Boletos</h3>
        <b-table v-if="!loading" striped hover :items="boletos" :fields="fields">
        </b-table>
        <Loading v-if="loading" :modoPR="pagRec" tamanho="100px" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "BoletosFluxo",
  props: ["boletos", "loading", "pagRec"],
  data() {
    return {
      fields: [
        {
          key: 'NUMERO_BOLETA',
          label: 'Nº Boleto',
          sortable: true
        },
        {
          key: 'VALOR',
          label: 'Valor',
          sortable: true,
          formatter: (value) => {
            return value.toLocaleString('pt-br', {
              style: 'currency', 
              currency: 'BRL'
            });
          }
        },
        {
          key: 'DATA_INCLUSAO',
          label: 'Data Inclusão',
          sortable: true,
          formatter: (value) => {
            return moment(value, "YYYYMMDD[T]HHmmss").format("DD/MM/YYYY [às] HH:mm:ss");
          }
        }
      ]
    };
  }
}
</script>

<style scoped>

</style>